module.exports = __webpack_public_path__ + "static/produkty_mirador-4172fbe35754ed1d77406add7ffd79ad.png";